/**
 * Série jaune ordinaire (tous les avertissements) pour Audit › Cumuls.
 * Calcul serveur : get_yellow_series_status, même règle que
 * reconcileYellowCommissions (mi-saison, paliers).
 */

export interface YellowSeriesIssued {
    sanctionId: string;
    threshold: number;
    /** 1 / 2 with the mid-season reset, null without. */
    phase: number | null;
    decisionDate: string;
}

export interface YellowSeriesRow {
    playerId: string;
    teamId: string | null;
    total: number;
    phase1: number;
    phase2: number;
    /** null when the mid-season reset is off. */
    currentPhase: number | null;
    /** Yellows of the current phase (the whole season without reset). */
    currentCount: number;
    nextThreshold: number | null;
    issued: YellowSeriesIssued[];
    midSeasonDate: string | null;
    player: { firstName: string | null; lastName: string | null; firstNameAr: string | null; lastNameAr: string | null };
    team: { name: string; name_ar: string | null } | null;
    /** Season licence (subject_licenses). */
    licenseNumber: string | null;
    /** players.license_number — season-less, search fallback only. */
    legacyLicenseNumber: string | null;
}

export function mapYellowSeriesRow(row: any): YellowSeriesRow {
    return {
        playerId: row.player_id,
        teamId: row.team_id ?? null,
        total: row.total ?? 0,
        phase1: row.phase1 ?? 0,
        phase2: row.phase2 ?? 0,
        currentPhase: row.current_phase ?? null,
        currentCount: row.current_count ?? 0,
        nextThreshold: row.next_threshold ?? null,
        issued: (row.issued ?? []).map((i: any) => ({
            sanctionId: i.sanction_id,
            threshold: i.threshold,
            phase: i.phase ?? null,
            decisionDate: i.decision_date,
        })),
        midSeasonDate: row.mid_season_date ?? null,
        player: {
            firstName: row.player_first_name ?? null,
            lastName: row.player_last_name ?? null,
            firstNameAr: row.player_first_name_ar ?? null,
            lastNameAr: row.player_last_name_ar ?? null,
        },
        team: row.team_name ? { name: row.team_name, name_ar: row.team_name_ar ?? null } : null,
        licenseNumber: row.license_number ?? null,
        legacyLicenseNumber: row.legacy_license_number ?? null,
    };
}

export const yellowSeriesIsNear = (r: YellowSeriesRow) =>
    r.nextThreshold != null && r.nextThreshold - r.currentCount === 1;

/** One yellow from the next threshold first, then by current count, then season total. */
export function sortYellowSeriesRows(rows: YellowSeriesRow[]): YellowSeriesRow[] {
    return [...rows].sort(
        (a, b) =>
            Number(yellowSeriesIsNear(b)) - Number(yellowSeriesIsNear(a)) ||
            b.currentCount - a.currentCount ||
            b.total - a.total ||
            a.playerId.localeCompare(b.playerId),
    );
}
